import ReportsTable from "./ReportsTable";

export default ReportsTable